<app-breadcrumb [title]="'Política de Seguridad Vial'" [items]="['Pesv']" [active_item]="'Política'"></app-breadcrumb>
<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-file-document me-2"></i>
      <h5 class="mb-0"><strong>POLÍTICA DE SEGURIDAD VIAL</strong></h5>
    </div>

    <div class="card-body">
      <div class="col-sm-12 col-xl-12">
        <div class="card-body p-2 p-md-3">
          <div class="card card-absolute rounded">
            <div class="card-header bg-primary d-flex justify-content-between align-items-center">
              <h5 class="text-white mb-0"><strong>HISTORIAL DE POLÍTICAS DE SEGURIDAD VIAL</strong></h5>
            </div>

            <div class="card-body">
          
              <div class="row mb-3">
                <div class="col-sm-12 col-md-3 ms-auto">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Buscar por versión, fecha o estado"
                      [value]="searchTextHistorialPolitica"
                      (input)="searchTextHistorialPolitica = $any($event.target).value; aplicarFiltroHistorialPolitica()"
                    />
                    <span class="input-group-text">
                      <i class="fa fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="table-responsive my-4">
                <table class="table table-hover table-bordered" id="tblPoliticas">
                  <thead class="bg-primary">
                    <tr>
                      <th class="text-center"><strong>CODIGO</strong></th>
                      <th class="text-center"><strong>VERSIÓN</strong></th>
                      <th class="text-center"><strong>DESIGNACIÓN</strong></th>
                      <th class="text-center"><strong>VENCIMIENTO</strong></th>
                      <th class="text-center"><strong>ESTADO</strong></th>
                      <th class="text-center"><strong>ACCIONES</strong></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let politica of historialPoliticasVista | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
                      <td class="text-center">{{ politica.codigo }}</td>
                      <td class="text-center">{{ politica.version }}</td>
                      <td class="text-center">{{ formatDateTodo(politica.fecha_designacion) }}</td>
                      <td class="text-center">{{ formatDateTodo(politica.fecha_vencimiento) }}</td>
                      <td class="text-center">
                        <span class="badge" [ngClass]="esPoliticaActiva(politica) ? 'bg-success' : 'bg-danger'">
                          {{ politica.estadoDocumento.nombre }}
                        </span>
                      </td>
                      <td class="text-center">
                        <div class="action text-center">
                          <ul class="list-inline mb-0">
                            <li class="edit" *ngIf="puedeEditarPolitica(politica)" (click)="editarPoliticaDesdeHistorial(politica); abrirModalEditarPolitica(modalEditarPolitica)" ngbTooltip="Editar">
                              <a href="javascript:void(0)"><i class="icon-pencil-alt"></i></a>
                            </li>

                            <li
                              class="delete"
                              *ngIf="esPoliticaActiva(politica)"
                              (click)="cambiarEstadoPolitica(politica, false)"
                              ngbTooltip="Inactivar"
                            >
                              <a href="javascript:void(0)"><i class="icon-close"></i></a>
                            </li>

                            <!--  <li
                              class="edit"
                              *ngIf="!esPoliticaActiva(politica)"
                              (click)="cambiarEstadoPolitica(politica, true)"
                              ngbTooltip="Activar"
                            >
                              <a href="javascript:void(0)"><i class="icon-check-box"></i></a>
                            </li> -->

                            <li class="edit" (click)="visualizarPDF(politica)" ngbTooltip="Previsualizar">
                              <a href="javascript:void(0)">
                                <span *ngIf="!descargandoPolitica"><i class="icon-eye"></i></span>
                                <span *ngIf="descargandoPolitica"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
                              </a>
                            </li>

                            <li class="edit" (click)="descargarDocumentoPolitica(politica)" ngbTooltip="Descargar">
                              <a href="javascript:void(0)">
                                <span *ngIf="!descargandoPolitica"><i class="icon-download"></i></span>
                                <span *ngIf="descargandoPolitica"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <div class="d-flex align-items-center">
                  <label for="pageSizePolitica" class="me-2">Mostrar:</label>
                  <select id="pageSizePolitica" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                  </select>
                  <span class="ms-2">registros por página</span>
                </div>

                <div class="text-center flex-grow-1">
                  Total Registros:
                  <a class="badge badge-primary"><b>{{ historialPoliticasVista.length }}</b></a>
                </div>

                <div class="text-end paginador-personalizado">
                  <pagination-controls
                    (pageChange)="page1 = $event"
                    [maxSize]="5"
                    [directionLinks]="true"
                    [autoHide]="true"
                    previousLabel="Anterior"
                    nextLabel="Siguiente"
                  >
                  </pagination-controls>
                </div>
              </div>

              <div class="mt-4">
                <div class="btn-showcase text-center">
                  <button
                    class="btn btn-outline-success-2x"
                    type="button"
                    placement="top"
                    ngbTooltip="Exportar a Excel"
                    (click)="exportarHistorialPoliticaExcel()"
                  >
                    <i class="icofont icofont-file-excel"></i> EXCEL
                  </button>

                  <button
                    class="btn btn-outline-danger-2x"
                    type="button"
                    placement="top"
                    ngbTooltip="Exportar a PDF"
                    (click)="exportarHistorialPoliticaPdf()"
                  >
                    <i class="icofont icofont-file-pdf"></i> PDF
                  </button>
                    <button
                    class="btn btn-outline-primary-2x"
                    type="button"
                    placement="top"
                    [disabled]="tienePoliticaVigente"
                    [ngbTooltip]="tienePoliticaVigente ? 'Ya existe una política vigente. No se puede crear otra.' : 'Crear política'"
                    (click)="abrirmodalCrear()"
                  >
                    <i class="icofont icofont-file-pdf"></i> CREAR POLITICA
                  </button>
                </div>
              </div>

              <div *ngIf="tienePoliticaVigente" class="alert alert-warning py-2 mb-0 mt-3" role="alert">
                Ya existe una política de seguridad vial vigente. Debe inactivar la actual o esperar a que venza para crear una nueva.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalCrearPolitica let-modal>
  <div class="modal-header bg-primary text-white">
    <div>
      <h5 class="modal-title d-flex align-items-center gap-2 mb-1">
        <i class="icofont icofont-file-document"></i>
        Crear Política de Seguridad Vial
      </h5>
      <p class="mb-0 small opacity-75">Complete los datos principales y adjunte el documento PDF.</p>
    </div>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="modal.dismiss()">
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="frmPoliticaPesv">
      <div class="card border-0 shadow-sm mb-3">
        <div class="card-body">
          <h6 class="fw-bold text-primary mb-3">
            <i class="icofont icofont-info-circle me-2"></i>
            Información general
          </h6>

          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label text-dark fw-semibold">
                Código <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="codigo"
                placeholder="PESV-POL-001">
              <small class="text-secondary fw-medium">Ingrese un identificador único para la política.</small>
            </div>

            <div class="col-md-6">
              <label class="form-label text-dark fw-semibold">
                Versión <span class="text-danger">*</span>
              </label>
              <input class="form-control" formControlName="version" placeholder="1.0">
              <small class="text-secondary fw-medium">Indique la versión actual del documento.</small>
            </div>

            <div class="col-md-6">
              <label class="form-label text-dark fw-semibold">
                Fecha creación <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                formControlName="fecha_designacion"
                [attr.max]="hoy"
                onkeydown="return false">
            </div>

            <div class="col-md-6">
              <label class="form-label text-dark fw-semibold">
                Fecha vencimiento <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                formControlName="fecha_vencimiento"
                [attr.min]="hoy"
                onkeydown="return false">
            </div>

            <div class="col-md-12">
              <label class="form-label text-dark fw-semibold">
                Estado de la política <span class="text-danger">*</span>
              </label>
              <select class="form-select" formControlName="estado">
                <option *ngFor="let estado of estadosPolitica" [value]="estado.id">
                  {{ estado.nombre }}
                </option>
              </select>
            </div>

            <div class="col-md-12">
              <label class="form-label text-dark fw-semibold">
                Motivo de creación o Cambio <span class="text-danger">*</span>
              </label>
              <textarea
                class="form-control"
                rows="3"
                formControlName="motivo_creacion"
                placeholder="Ej. Renovación por vencimiento de la política anterior o actualización por cambios normativos"
              ></textarea>
              <small class="text-secondary fw-medium">Describa brevemente el motivo por el cual se está creando  o modificando esta política.</small>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <h6 class="fw-bold text-primary mb-3">
            <i class="icofont icofont-file-pdf me-2"></i>
            Política de Seguridad Vial - Documento PDF
          </h6>

          <input type="file" class="d-none" id="fileInputActaPdf" accept=".pdf" (change)="onPdfFileSelected($event)" />

          <label for="fileInputActaPdf"
            class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary border-2 rounded-3 cursor-pointer bg-light"
            tabindex="0"
            (dragover)="onDragOverPdf($event)"
            (dragleave)="onDragLeavePdf($event)"
            (drop)="onDropPdfActa($event)">

            <ng-container *ngIf="pdfFileSelected; else noFileActaPdf">
              <i class="icofont icofont-file-pdf fs-1 text-danger mb-2"></i>
              <div class="text-center">
                <div class="fw-bold text-primary">{{ pdfFileSelected?.name }}</div>
                <small class="text-secondary fw-medium">{{ formatFileSize(pdfFileSelected.size) }}</small>
              </div>
            </ng-container>

            <ng-template #noFileActaPdf>
              <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
              <h6 class="mb-1 text-primary">Cargar PDF</h6>
              <small class="text-dark">Arrastre el archivo aquí o haga clic para seleccionarlo</small>
            </ng-template>
          </label>

          <div *ngIf="pdfFileSelected" class="d-flex justify-content-center mt-3">
            <button class="btn btn-outline-danger px-4" type="button" (click)="removePdfActaSeleccionado()">
              <i class="icofont icofont-trash me-2"></i>
              Eliminar archivo
            </button>
          </div>

          <small class="text-secondary fw-medium d-block mt-2">
            Solo se permite archivo PDF con un tamaño máximo de 10 MB.
          </small>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      <i class="icofont icofont-close me-1"></i>
      Cancelar
    </button>

    <button
      type="button"
      class="btn btn-primary"
      [disabled]="frmPoliticaPesv.invalid"
      (click)="guardarPolitica()">
      <i class="icofont icofont-save me-1"></i>
      Guardar Política
    </button>
  </div>
</ng-template>

<!-- Modal para Editar Política -->
<ng-template #modalEditarPolitica let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">Editar Política de Seguridad Vial</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="formEditarPolitica">
      <div class="row g-3 mb-3">
        <div class="col-12 col-md-4">
          <label class="form-label text-dark fw-bold">Versión: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            placeholder="Ej: 1.0"
            formControlName="codigo"
            [class.is-invalid]="formEditarPolitica.get('codigo')?.invalid && formEditarPolitica.get('codigo')?.touched"
          />
          <div class="invalid-feedback">El código es obligatorio.</div>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label text-dark fw-bold">Fecha designación: <span class="text-danger">*</span></label>
          <input
            type="date"
            class="form-control"
            formControlName="fecha_designacion"
            [max]="fechaDesignacionMax"
            [class.is-invalid]="formEditarPolitica.get('fecha_designacion')?.invalid && formEditarPolitica.get('fecha_designacion')?.touched"
          />
          <div class="invalid-feedback">La fecha de designación es obligatoria.</div>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label text-dark fw-bold">Fecha vencimiento: <span class="text-danger">*</span></label>
          <input
            type="date"
            class="form-control"
            formControlName="fecha_vencimiento"
            [class.is-invalid]="formEditarPolitica.get('fecha_vencimiento')?.invalid && formEditarPolitica.get('fecha_vencimiento')?.touched"
          />
          <div class="invalid-feedback">La fecha de vencimiento es obligatoria.</div>
        </div>

        <div class="col-12 col-md-12">
          <label class="form-label text-dark fw-bold">Estado de la política: <span class="text-danger">*</span></label>
          <select class="form-select" formControlName="estado">
            <option *ngFor="let estado of estadosPolitica" [value]="estado.id">
              {{ estado.nombre }}
            </option>
          </select>
        </div>
      </div>

      <!-- Sección de Reemplazar Documento -->
      <div class="card card-absolute rounded mt-4">
        <div class="card-body">
          <label class="form-label text-dark fw-bold">Reemplazar documento</label>
          <input type="file" class="form-control" (change)="onFileChangeEditar($event)" [accept]="acceptDocumentoPolitica" />

          <div *ngIf="archivoSeleccionadoEditar" class="archivo-info p-3 bg-light rounded mt-3">
            <div class="d-flex align-items-start mb-3">
              <i class="icofont icofont-file-document text-primary me-3" style="font-size: 32px;"></i>
              <div class="flex-grow-1">
                <strong>{{ archivoSeleccionadoEditar.name }}</strong>
                <div class="small text-secondary fw-medium">Tamaño: {{ (archivoSeleccionadoEditar.size / 1024).toFixed(2) }} KB</div>
              </div>
            </div>
 
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-danger flex-grow-1" (click)="eliminarArchivoEditar()">
                <i class="icofont icofont-trash"></i> Eliminar archivo seleccionado
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="guardarCambiosPolitica(modal)"
      [disabled]="cargandoEditarPolitica"
    >
      <span *ngIf="!cargandoEditarPolitica">
        <i class="icofont icofont-save me-1"></i>Guardar Cambios
      </span>
      <span *ngIf="cargandoEditarPolitica">
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Guardando...
      </span>
    </button>
  </div>
</ng-template>

  <ng-template #modalVisualizarPolitica let-modal>
    <div class="modal-header bg-primary text-white">
      <h5 class="modal-title">Previsualizar Documento</h5>
      <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div *ngIf="pdfUrl; else cargandoPreview">
        <div style="width:100%; height:75vh;">
          <iframe [src]="pdfUrl" width="100%" height="100%" style="border:0;"></iframe>
        </div>
      </div>
      <ng-template #cargandoPreview>
        <div class="text-center py-5">
          <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
          <p class="mt-2">Cargando documento...</p>
        </div>
      </ng-template>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
  </ng-template>